import React from 'react';
import {googleAnalyticsSimplePageView} from '../utils/google-analytics-utils';

export default class Timeout extends React.Component {

  componentDidMount() {
    googleAnalyticsSimplePageView();
  }

  render() {
    return (
      <div className="d-flex align-items-center justify-content-center flex-column" style={{height: '100vh'}}>
        <img src={`${process.env.PUBLIC_URL}/images/timeout.png`} />
        <h2>Sorry, your secure session has expired.</h2>
      </div>
    )
  }
}